import { useState } from 'react';

interface Props {
  reasons: string[];
  title: string;
  // Sólo PreVenta: permite registrar la visita como anulada.
  allowVoided?: boolean;
  error?: string;
  onConfirm: (reason: string, explain: string, voided: boolean) => void;
  onDiscard: () => void;
}

// Panel de cancelación del detalle de visita para el rol Proper.
const ProperCancelPanel = ({
  reasons,
  title,
  allowVoided,
  error,
  onConfirm,
  onDiscard,
}: Props) => {
  const [reason, setReason] = useState('');
  const [explain, setExplain] = useState('');
  const [voided, setVoided] = useState(false);

  return (
    <div className="vd-cancel">
      <h3 className="vd-cancel__title">{title}</h3>
      <select
        className="vd-input"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        aria-label="Motivo de la cancelación"
      >
        <option value="">Selecciona un motivo</option>
        {reasons.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
      <textarea
        className="vd-input"
        rows={2}
        value={explain}
        onChange={(e) => setExplain(e.target.value)}
        placeholder="Comentario adicional (opcional)"
      />
      {allowVoided && (
        <label className="vd-check">
          <input
            type="checkbox"
            checked={voided}
            onChange={(e) => setVoided(e.target.checked)}
          />
          Registrar como anulada
        </label>
      )}
      {error && <p className="vd-panel__error">{error}</p>}
      <div className="vd-cancel__actions">
        <button
          type="button"
          className="vd-btn vd-btn--solid-danger"
          onClick={() => onConfirm(reason, explain, voided)}
          disabled={!reason}
        >
          Confirmar cancelación
        </button>
        <button type="button" className="vd-btn vd-btn--ghost" onClick={onDiscard}>
          Descartar
        </button>
      </div>
    </div>
  );
};

export default ProperCancelPanel;
